import coverUrl from "./decision-architecture-cover.webp";
import portraitUrl from "./portrait-andreas-rieger.webp";

export const decisionArchitectureCover = {
  url: coverUrl,
  width: 840,
  height: 1247,
};

export const portrait = {
  url: portraitUrl,
  width: 1000,
  height: 667,
};
